<span class="alerts"> {{ newAlertCounts().total }} </span>
<label> {{ 'NEW_ALERTS' | translate }} : </label>

<app-alert-severity [severity]="ALERT_SEVERITY.HIGH" [size]="16" class="severity-high" />
<span> {{ newAlertCounts().high }} </span>

<app-alert-severity [severity]="ALERT_SEVERITY.NORMAL" [size]="16" class="severity-normal" />
<span> {{ newAlertCounts().normal }} </span>
